import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function AdminRoute() {
  const { token, user, initialized } = useSelector((s) => s.auth);

  if (!token) return <Navigate to="/auth/login" replace />;
  if (!initialized) return <div className="flex items-center justify-center h-screen text-stone-500">Loading…</div>;
  if (!['manager', 'admin'].includes(user?.role)) return <Navigate to="/dashboard" replace />;

  return <Outlet />;
}
